import React, { useEffect, useState } from "react";
import Spinner from "react-bootstrap/Spinner";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { getAppSettings } from "../api/api";
import Login from "../pages/auth/login";

const LoginGate = () => {
  const [clientId, setClientId] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const run = async () => {
      try {
        const res = await getAppSettings();
        setClientId(res?.data?.info?.google_login_client_id || "");
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    run();
  }, []);

  if (loading || !clientId) {
    return (
      <div style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <Login checkout />
    </GoogleOAuthProvider>
  );
};

export default LoginGate;

